import React from "react";
import "./NotificationItem.sass";
import moment from "moment";

export default function NotificationItem({notification, onMouseEnter}) {

    return (
        <div className={`NotificationItem-wrapper ${notification.status === 'SENT' && 'NotificationItem-wrapper-not-read'}`}
             onMouseEnter={notification.status === "SENT" ? onMouseEnter : (() => {})}>

            <div className="NotificationItem-time">
                {moment(notification.dateTime, "YYYY-MM-DDTHH:mm:SS").calendar()}
            </div>
            <div className="NotificationItem-title">
                {notification.title}
            </div>
            <div className="NotificationItem-message">
                {notification.message}
            </div>
        </div>
    )
}